<template>
  <div
    class="game-iframe-page"
    :class="{ 'is-mobile-shell': isMobileShell }"
  >
    <div class="game-iframe-shell">
      <button
        type="button"
        class="game-iframe-home"
        aria-label="Home"
        @click="goHome"
      >
        <i class="fa fa-home" aria-hidden="true"></i>
      </button>

      <iframe
        name="iframe1"
        :srcdoc="isHttp ? null : iframeUrl"
        :src="isHttp ? iframeUrl : null"
        class="game-iframe"
        allow="autoplay; fullscreen; payment; clipboard-read; clipboard-write"
        allowfullscreen
        referrerpolicy="no-referrer-when-downgrade"
      />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    iframeUrl() {
      return this.$store.state.iframeURL || '';
    },
    isMobileShell() {
      return !!this.$store.state.iframeMobileView;
    },
    // http(s) and blob: use src; raw HTML uses srcdoc
    isHttp() {
      const url = this.iframeUrl;
      return url.startsWith('http') || url.startsWith('blob:');
    },
  },
  mounted() {
    if (!this.iframeUrl) {
      this.$router.replace('/home');
      return;
    }
    document.body.classList.add('game-iframe-open');
  },
  beforeDestroy() {
    document.body.classList.remove('game-iframe-open');
    const url = this.iframeUrl;
    if (url && url.startsWith('blob:')) {
      try {
        URL.revokeObjectURL(url);
      } catch (e) {
        /* ignore */
      }
    }
  },
  methods: {
    goHome() {
      this.$store.commit('setIframeURL', null);
      this.$router.push('/home');
    },
  },
};
</script>

<style scoped>
.game-iframe-page {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  z-index: 99999;
  background: #04090a;
  overflow: hidden;
}

.game-iframe-shell {
  position: relative;
  width: 100%;
  height: 100%;
  background: #04090a;
  overflow: hidden;
}

.game-iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  background: #04090a;
}

.game-iframe-home {
  position: absolute;
  top: max(10px, env(safe-area-inset-top));
  left: max(10px, env(safe-area-inset-left));
  z-index: 100000;
  width: 42px;
  height: 42px;
  border: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  background: #0D3B1A;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.45);
  cursor: pointer;
  opacity: 0.92;
  transition: transform 0.15s ease, opacity 0.15s ease;
}

.game-iframe-home:hover,
.game-iframe-home:focus {
  opacity: 1;
  transform: scale(1.05);
  outline: none;
}

.game-iframe-home:active {
  transform: scale(0.96);
}

.game-iframe-home .fa-home {
  font-size: 1.15rem;
  line-height: 1;
}

/* PC: phone-width shell (matches app col-lg-4 look) for Forest / Galone */
@media (min-width: 992px) {
  .game-iframe-page.is-mobile-shell {
    display: flex;
    align-items: stretch;
    justify-content: center;
    background: #FFFFFF;
  }

  .game-iframe-page.is-mobile-shell .game-iframe-shell {
    /* Match app phone shell (Index.vue col-lg-4) */
    width: min(520px, 40vw);
    height: 100%;
    box-shadow: 0 0 0 1px rgba(13, 59, 26, 0.2), 0 18px 48px rgba(0, 0, 0, 0.55);
  }
}
</style>

<style>
body.game-iframe-open {
  overflow: hidden !important;
}
</style>
